<template>
  <AppShell>
    <router-view />
    <Toast />
  </AppShell>
</template>

<script setup lang="ts">
import AppShell from '@/layouts/AppShell.vue'
import Toast from '@/components/Toast.vue'
</script>
